const Dashboard = () => (
    <div>
        <div>AI Trainer</div>
    </div>
);

export default Dashboard;
